module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_ali_1.9c136855.jpg";